import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Input from '../Input';

import InputDate from '../InputDate';

export const StyledBox = styled.div`
  margin-bottom: ${rem('31px')};
  ${mediaqueries.greaterThan('desktop')`
    margin-bottom: ${rem('40px')};
  `};
`;

export const StyledTitle = styled.h2`
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  border-bottom: 0;
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.xsmall};
  line-height: ${rem('15px')};
  margin: 0;
  padding: ${rem('6px')} ${rem('10px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    border: 0;
    border-bottom: ${rem('2px')} solid ${props => props.theme.colors.dark};
    font-family: ${props => props.theme.fonts.medium};
    font-size: ${props => props.theme.fontSize.small};
    padding-left: 0;
  `};
`;

export const StyledList = styled.ul`
  margin: 0;
  padding-left: 0;
  ${mediaqueries.greaterThan('desktop')`
    border-top: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  `};
`;

export const StyledElements = styled.li`
  background-color: ${props => props.theme.colors.grayMoreLight};
  border: ${rem('1px')} solid ${props => props.theme.colors.grayLighter};
  margin-bottom: ${rem('5px')};
  padding: ${rem('14px')} ${rem('10px')} ${rem('20px')} ${rem('10px')};
  :before {
    content: none;
  }
  ${mediaqueries.greaterThan('desktop')`
    border-top: 0;
    margin: 0;
    padding: ${rem('13px')} ${rem('20px')} ${rem('13px')} ${rem('10px')};
  `};
`;

export const StyleBoxForm = styled.div`
  ${mediaqueries.greaterThan('desktop')`
    align-items: center;
    display: flex;
    justify-content: space-between;
  `};
`;

export const StyleInputDate = styled(InputDate)`
  margin-top: ${rem('15px')};
  width: ${rem('240px')};
  ${mediaqueries.greaterThan('desktop')`
    flex-shrink: 0;
    margin: 0 0 0 ${rem('25px')};
    width: ${rem('162px')};
  `};
`;

export const StyleInput = styled(Input)`
  margin-top: ${rem('15px')};
  ${mediaqueries.greaterThan('desktop')`
    flex-shrink: 0;
    margin: 0 0 0 ${rem('25px')};
    width: ${rem('110px')};
  `};
`;
